//React
import React from 'react';

//pages
import { ProvidersManagement } from 'pages/providers';
import { useUserProviderManagementData } from './useUserProviderManagementData';

export const UserProvidersManagement: React.FC = () => {
  const {
    providers,
    payors,
    roles,
    currentSite,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    refetchProviders,
    setIsLoading,
  } = useUserProviderManagementData();

  return (
    <ProvidersManagement
      providers={providers}
      roles={roles}
      currentSite={currentSite}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      refetchProviders={refetchProviders}
      errorMessage={errorMessage}
      payors={payors}
      setIsLoading={setIsLoading}
    />
  );
};
